export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            黑料每日大赛创立于2023年，是中文互联网领先的娱乐资讯聚合平台。我们致力于为每一位吃瓜群众提供最快、最全、最真实的每日爆料与黑料合集。
          </p>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            平台每日更新超过1200条爆料内容，覆盖明星八卦、网红翻车、综艺名场面、社会热点等多个领域。我们的编辑团队由资深娱乐记者和网络文化研究者组成，坚持多方信源交叉验证，标注每一条信息的可信度等级，拒绝成为谣言传播者。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            黑料每日大赛不仅是一个吃瓜平台，更是一个有态度的内容社区。我们关注网络文化的健康发展，倡导理性吃瓜、文明讨论。欢迎每一位热爱吃瓜的朋友加入我们，一起见证中文互联网最精彩的每一刻。
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
            {[
              { num: '3年', label: '持续运营' },
              { num: '86,500+', label: '累计爆料' },
              { num: '32.6万', label: '注册用户' },
              { num: '99.7%', label: '内容可信度' },
            ].map((stat) => (
              <div key={stat.label} className="p-4 rounded-lg bg-background-100 border border-background-200/60">
                <div className="text-xl md:text-2xl font-heading text-primary-600">{stat.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}